import Button from "@/components-library/widgets/button/button";
import classes from "../visura-to-excel.module.scss";
import Label from "@/components-library/widgets/label";

function VisuraButtonsRendering({
  onCopyToClipboardButtonCLick,
  onResetButtonClick,
  apiResponse,
  lastFileName,
}) {
  return (
    <>
      {lastFileName?.length > 0 && (
        <Label
          tag={"h7"}
          color={"navbar"}
          weight={"normal"}
          align={"center"}
          className={classes.filename}
        >
          file attualmente caricato : {lastFileName}
        </Label>
      )}

      <Button
        onClick={onCopyToClipboardButtonCLick}
        isEnabled={apiResponse?.length > 0}
        size="sm"
        color="primary"
        className={classes.button}
      >
        COPIA RISULTATO NEGLI APPUNTI
      </Button>
      <Button
        onClick={onResetButtonClick}
        size="sm"
        color="primary"
        className={classes.button}
      >
        PULISCI APPUNTI
      </Button>
    </>
  );
}

export default VisuraButtonsRendering;
